import { Box, Stack } from '@mui/material';
import { useIsDesktop } from 'Hooks';
import { PaymentDeductionState } from './PaymentDeductionState';
import { PaymentDeductionNumber } from './PaymentDeductionNumber';
import { PaymentDeductionType } from './PaymentDeductionType';

export const SearchFields = () => {
  const isDesktop = useIsDesktop();

  return (
    <Stack
      direction='column'
      zIndex={1}
      width='100%'
      gap={isDesktop ? '48px' : '24px'}
    >
      <Stack
        direction={isDesktop ? 'row' : 'column'}
        gap={isDesktop ? '64px' : '24px'}
        alignItems='center'
      >
        <Box width={isDesktop ? '425px' : '100%'} flexShrink={0}>
          <PaymentDeductionState />
        </Box>
        <Box width={isDesktop ? '425px' : '100%'} flexShrink={0}>
          <PaymentDeductionNumber />
        </Box>
      </Stack>
      <Stack
        direction={isDesktop ? 'row' : 'column'}
        gap={isDesktop ? '64px' : '24px'}
        alignItems='center'
        width={isDesktop ? '425px' : '100%'}
        flexShrink={0}
      >
        <PaymentDeductionType />
      </Stack>
    </Stack>
  );
};
